import { ValueType, YesOrNo, parseFormValue } from './formFieldConstants';
import React from 'react';

export const createFamilyPetColumns = (vendors, enumerations) => {

  const petTypes =
    enumerations && enumerations.petTypes && enumerations.petTypes.length > 0
      ? enumerations.petTypes.filter(s => s.isActive === true)
      : [{ id: '00000000-0000-0000-0000-000000000000', title: '' }];

  return [
    {
      accessorKey: 'name',
      header: 'Pet Name',
      type: 'text',
      required: true,
      hideInTable: false,
      size: 65
    },
    {
      accessorKey: 'petTypeId',
      header: 'Type',
      type: 'dropdown-v2',
      required: true,
      options: petTypes,
      hideInTable: false,
      size: 65,
      Cell: ({ cell }) => <div>{petTypes.find(at => at.id === cell.row.original.petTypeId)?.title}</div>
    },
    {
      accessorKey: 'breed',
      header: 'Breed',
      type: 'text',
      required: true,
      hideInTable: false,
      size: 65
    },
    {
      accessorKey: 'age',
      header: 'Age',
      type: 'number',
      required: true,
      hideInTable: false,
      size: 65
    },
    {
      accessorKey: 'petWeightInLbs',
      header: 'Weight (lbs)',
      type: 'number',
      required: true,
      hideInTable: false,
      size: 65
    },
    {
      accessorKey: 'specialNeeds',
      header: 'Special Needs',
      type: 'notes',
      required: false,
      hideInTable: false,
      size: 65
    },
    {
      accessorKey: 'comments',
      header: 'Comments',
      type: 'notes',
      required: false,
      hideInTable: true
    }
  ];
};

export const createFamilyPetRows = (formDataList, vendors) => {
  if (!formDataList || !Array.isArray(formDataList)) {
    return [];
  }

  return formDataList.map(data => mapPetRow(data));
};

export const mapPetRow = (data, vendors) => {
  return {
    ...data,
    requiredDocumentationOnAnimal: data?.requiredDocumentationOnAnimal ? YesOrNo[0] : YesOrNo[1],
    requiredVaccines: data?.requiredVaccines ? YesOrNo[0] : YesOrNo[1],

    vendorPhoneNumber: data?.vendorId && vendors ? vendors.find(v => v.vendorId === data?.vendorId)?.phone : '',
    vendorEmail: data?.vendorId && vendors ? vendors.find(v => v.vendorId === data?.vendorId)?.vendorEmail : '',

    departureDate: parseFormValue(data.departureDate, ValueType.DateTimeType),
    arrivalDate: parseFormValue(data.arrivalDate, ValueType.DateTimeType)
  };
};

export const getNameOfDeletePetRow = row => {
  return `${row.getValue('petName') ?? ''}`;
};

export const createFamilyPetPostRequest = (formData, authorizationId) => {
  const request = { ...formData };
  request.authorizationId = authorizationId;
  request.fileId = Number(authorizationId);

  parseFamilyPetFormValues(request, formData);
  return request;
};

export const createFamilyPetPutRequest = (originalFormData, newFormData, authorizationId) => {
  const request = { ...newFormData };
  request.authorizationId = authorizationId;
  request.familyPetId = originalFormData.familyPetId;
  request.fileId = originalFormData.fileId;
  request.rowVersion = originalFormData.rowVersion;

  parseFamilyPetFormValues(request, newFormData);
  return request;
};

const parseFamilyPetFormValues = (currentRequest, newRequestValues) => {
  currentRequest.requiredDocumentationOnAnimal = newRequestValues.requiredDocumentationOnAnimal === YesOrNo[0];
  currentRequest.requiredVaccines = newRequestValues.requiredVaccines === YesOrNo[0];

  currentRequest.departureDate = parseFormValue(newRequestValues.departureDate, ValueType.DateTimeType);
  currentRequest.arrivalDate = parseFormValue(newRequestValues.arrivalDate, ValueType.DateTimeType);

  currentRequest.age = parseFormValue(newRequestValues.age, ValueType.IntType);
  currentRequest.petWeightInLbs = Number(parseFormValue(newRequestValues.petWeightInLbs, ValueType.IntType));
  currentRequest.carrierWeightInLbs = newRequestValues.carrierWeight ? parseFormValue(newRequestValues.carrierWeight, ValueType.IntType) : 0;
  currentRequest.vendorId = parseFormValue(newRequestValues.vendorId, ValueType.IntType);

  currentRequest.costOfQuarantine = parseFormValue(newRequestValues.costOfQuarantine, ValueType.FloatType);

  currentRequest.arrivalDateTime = newRequestValues.arrivalDate ? newRequestValues.arrivalDate : null;
  currentRequest.departureDateTime = newRequestValues.departureDate ? newRequestValues.departureDate : null;
  currentRequest.airline = newRequestValues.airline ? newRequestValues.airline : '';
  currentRequest.flightNumber = newRequestValues.flightNumber ? newRequestValues.flightNumber : '';
  currentRequest.arrivalAirport = newRequestValues.arrivalAirport ? newRequestValues.arrivalAirport : '';
  currentRequest.lengthOfQuarantineInDays = newRequestValues.lengthOfQuarantineInDays ? newRequestValues.lengthOfQuarantineInDays : 0;
  currentRequest.costOfQuarantine = newRequestValues.costOfQuarantine ? newRequestValues.costOfQuarantine : 0;
  currentRequest.isDocumentationRequired = newRequestValues.isDocumentationRequired ? newRequestValues.isDocumentationRequired : false;
  currentRequest.isVaccinesRequired = newRequestValues.isVaccinesRequired ? newRequestValues.isVaccinesRequired : false;
  currentRequest.rowVersion = newRequestValues.rowVersion ? newRequestValues.rowVersion : undefined;

  currentRequest.addedBy = 1;
  currentRequest.modifiedBy = 1;
};
